import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { CancelOrderButton } from '../../../../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import IncrementButton from '../../../../../../../../../../atomic/buttons/incrementButton/IncrementButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import {
  Body3,
  fontSizes,
} from '../../../../../../../../../../atomic/text/Text';
import style from './AddGrabCents.module.css';

export const AddGrabCentsRightBody = ({ details, setDetails }) => {
  const [qtyBasisValue, setQtyBasisValue] = useState(0);
  const [centsValue, setCentsValue] = useState(0);
  const takeProfitMode = details.takeProfitMode;
  return (
    <tbody>
      {details.grabCentsMode === 'PERCENT'
        ? details.percentagePerLevel.map((percentage, index) => {
          return (
            <tr key={'' + percentage + details.centsPerLevel[index]}>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {index + 1}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {takeProfitMode === 'DOLLARS'
                    ? details.centsPerLevel[index]
                    : Number(details.centsPerLevel[index]) * 100}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {percentage * 100}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <CancelOrderButton
                  width={10}
                  clickHandler={() => {
                    const arrCopy = [...details.percentagePerLevel];
                    const filteredArr = arrCopy.filter(
                      (item, i) => i !== index
                    );
                    setDetails((prev) => ({
                      ...prev,
                      percentagePerLevel: filteredArr,
                    }));
                  }}
                />
              </td>
            </tr>
          );
        })
        : details.quantityPerLevel.map((quantity, index) => {
          return (
            <tr key={'' + quantity + details.centsPerLevel[index]}>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {index + 1}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {takeProfitMode === 'DOLLARS'
                    ? details.centsPerLevel[index]
                    : Number(details.centsPerLevel[index]) * 100}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <Body3 fontWeight={700} color={colors.lightGrey}>
                  {quantity}
                </Body3>
              </td>
              <td className={style.labelTd}>
                <div className={style.inputWrapper}>
                  <CancelOrderButton
                    width={10}
                    clickHandler={() => {
                      const arrCopy = [...details.quantityPerLevel];
                      const filteredArr = arrCopy.filter(
                        (item, i) => i !== index
                      );
                      setDetails((prev) => ({
                        ...prev,
                        quantityPerLevel: filteredArr,
                      }));
                    }}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Add
          </Body3>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            {takeProfitMode === 'DOLLARS' ? <Body3
              fontWeight={700}
              color={colors.lightGrey}
              margin="3px 3px 0 0"
            >
              $
            </Body3> : null}
            <EditableTableFieldNoOnBlurUpdate
              inputType="number"
              fontSize={fontSizes.Body3}
              value={centsValue}
              setValue={(value) => setCentsValue(value)}
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
            {takeProfitMode === 'PERCENT' ? <Body3
              fontWeight={700}
              color={colors.lightGrey}
              margin="3px 3px 0 0"
            >
              %
            </Body3> : null}
          </div>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            {details.grabCentsMode === 'QUANTITY' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                #
              </Body3>
            ) : null}
            <EditableTableFieldNoOnBlurUpdate
              inputType="number"
              fontSize={fontSizes.Body3}
              value={qtyBasisValue}
              setValue={(value) => setQtyBasisValue(value)}
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
            {details.grabCentsMode === 'PERCENT' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                %
              </Body3>
            ) : null}
          </div>
        </td>
        <td className={style.labelTd}>
          <div className={style.inputWrapper}>
            <IncrementButton
              paddingPercent={10}
              color={colors.white}
              backgroundColor={colors.blue}
              width={10}
              stroke={1}
              handleClick={() => {
                let cents;
                if (takeProfitMode === 'DOLLARS') cents = centsValue;
                else cents = Number(centsValue) / 100;
                if (
                  qtyBasisValue !== '' &&
                  qtyBasisValue !== 0 &&
                  centsValue !== '' &&
                  centsValue !== 0 &&
                  details.grabCentsMode === 'PERCENT'
                ) {
                  setDetails((prev) => ({
                    ...prev,
                    centsPerLevel: [...prev.centsPerLevel, cents],
                    percentagePerLevel: [
                      ...prev.percentagePerLevel,
                      qtyBasisValue / 100,
                    ],
                  }));
                } else {
                  setDetails((prev) => ({
                    ...prev,
                    centsPerLevel: [...prev.centsPerLevel, cents],
                    quantityPerLevel: [...prev.quantityPerLevel, qtyBasisValue],
                  }));
                }
              }}
              buttonWidth={15}
            />
          </div>
        </td>
      </tr>
    </tbody>
  );
};

AddGrabCentsRightBody.propTypes = {
  details: PropTypes.shape({
    centsPerLevel: PropTypes.any,
    grabCentsMode: PropTypes.string,
    percentagePerLevel: PropTypes.array,
    takeProfitMode: PropTypes.string,
    quantityPerLevel: PropTypes.array,
  }),
  setDetails: PropTypes.func,
};
